var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "formValidation",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ invalid }) {
          return [
            _c(
              "form",
              {
                staticClass: "form-horizontal p-t-10 p-b-10",
                attrs: { role: "form", name: "annotateForm", novalidate: "" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.annotateCallSubmit.apply(null, arguments)
                  }
                }
              },
              [
                _vm.recentTags && _vm.recentTags.length > 0
                  ? _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        { staticClass: "col-sm-2 col-md-3 control-label" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("PREVIOUS_LABEL")) + "\n        "
                          ),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.right",
                                  value: _vm.$t("PREVIOUS_TT"),
                                  expression: "$t('PREVIOUS_TT')",
                                  modifiers: { right: true }
                                }
                              ]
                            },
                            [
                              _vm._v("\n            "),
                              _c("i", { staticClass: "fa fa-question-circle" })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-3" },
                        [
                          _c("SearchableDropdown", {
                            attrs: { config: _vm.recentTagsDropdownConfig },
                            model: {
                              value: _vm.dropdownTag,
                              callback: function($$v) {
                                _vm.dropdownTag = $$v
                              },
                              expression: "dropdownTag"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    { staticClass: "col-sm-2 col-md-3 control-label" },
                    [
                      _vm._v(_vm._s(_vm.$t("TAG_NAME_LABEL")) + "\n        "),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.right",
                              value: _vm.$t("TAG_NAME_TT"),
                              expression: "$t('TAG_NAME_TT')",
                              modifiers: { right: true }
                            }
                          ]
                        },
                        [
                          _vm._v("\n            "),
                          _c("i", { staticClass: "fa fa-question-circle" })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-3 col-md-2" },
                    [
                      _c("ValidationProvider", {
                        attrs: { rules: "required", slim: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ classes }) {
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.tag.name,
                                        expression: "tag.name"
                                      },
                                      { name: "focus", rawName: "v-focus" }
                                    ],
                                    staticClass: "form-control",
                                    class: classes,
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "TAG_NAME_PLACEHOLDER"
                                      )
                                    },
                                    domProps: { value: _vm.tag.name },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.tag,
                                          "name",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    { staticClass: "col-sm-2 col-md-3 control-label" },
                    [
                      _vm._v(_vm._s(_vm.$t("TAG_VALUE_LABEL")) + "\n        "),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.right",
                              value: _vm.$t("TAG_VALUE_TT"),
                              expression: "$t('TAG_VALUE_TT')",
                              modifiers: { right: true }
                            }
                          ]
                        },
                        [
                          _vm._v("\n            "),
                          _c("i", { staticClass: "fa fa-question-circle" })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-3 col-md-2" },
                    [
                      _c("ValidationProvider", {
                        attrs: { rules: "required", slim: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ classes }) {
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.tag.value,
                                        expression: "tag.value"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: classes,
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "TAG_VALUE_PLACEHOLDER"
                                      )
                                    },
                                    domProps: { value: _vm.tag.value },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.tag,
                                          "value",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-offset-2 col-md-offset-3 col-md-7" },
                    [
                      _c(
                        "PrimaryButton",
                        {
                          attrs: {
                            size: "sm",
                            disabled: invalid,
                            "show-loader-on-form": _vm.showLoader
                          },
                          on: { click: _vm.annotateCallSubmit }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("ADD_ANNOTATION_BTN")) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("button", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "CANCEL",
                            expression: "'CANCEL'"
                          }
                        ],
                        staticClass: "btn btn-sm btn-danger m-l-15",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("closeForm")
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }